import { defineStore } from 'pinia'

export const useLangStore = defineStore('lang', {
  state: () => {
    return {
      currentLang: 'zh-CN' // 默认语言
    }
  },
  actions: {
    setLang(lang: string) {
      this.currentLang = lang
    }
  }
}) 